import {
    CREATE_SLIDER, DELETE_SLIDER,
    FETCH_SLIDER,
    FETCH_SLIDERS,
    LIST_SLIDERS,
    SHOW_SLIDER,
    UPDATE_SLIDER,
    // optionally add:
    // DELETE_SLIDER,
    // SET_SLIDER_ERROR,
} from "./types";

const iniPaging = {
    page: 1,
    totals: 0,
    size: 25,
};

const init = {
    ...iniPaging,
    isLoading: false,
    list: [],
    error: null,
};

function upsertById(list, item) {
    if (!item?.id) return list;
    const idx = list.findIndex((x) => String(x.id) === String(item.id));
    if (idx === -1) return [item, ...list];
    const next = [...list];
    next[idx] = {...next[idx], ...item};
    return next;
}

export default function sliderReducer(state = init, {type, payload}) {
    switch (type) {
        case FETCH_SLIDERS:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case LIST_SLIDERS: {
            // payload expected: { list, totals, size, page }
            // totals can be derived if not provided
            const list = Array.isArray(payload?.list) ? payload.list : [];
            const totals = Number(payload?.totals) || list.length;

            return {
                ...state,
                list,
                totals,
                size: Number(payload?.size) || state.size,
                page: Number(payload?.page) || state.page,
                isLoading: false,
                error: null,
            };
        }

        case FETCH_SLIDER:
            return {
                ...state,
            };

        case SHOW_SLIDER:
            return {
                ...state,
            };

        case CREATE_SLIDER: {
            // If your action returns API payload shape:
            // { status, messageKey, data: createdSlider }
            const created = payload?.data;
            if (created && typeof created === "object") {
                const nextList = upsertById(state.list, created);
                return {
                    ...state,
                    list: nextList,
                    totals: nextList.length,
                    isLoading: false,
                    error: null,
                };
            }

            // fallback: you may be re-fetching after create
            return {
                ...state,
                isLoading: false,
                error: null,
            };
        }

        case UPDATE_SLIDER: {
            const updated = payload?.data;
            if (updated && typeof updated === "object") {
                const nextList = upsertById(state.list, updated);
                return {
                    ...state,
                    list: nextList,
                    totals: nextList.length,
                    isLoading: false,
                    error: null,
                };
            }

            return {
                ...state,
                isLoading: false,
                error: null,
            };
        }

        case DELETE_SLIDER: {
            const id = payload;
            const newList = state.list.filter(
                (item) => String(item.id) !== String(id)
            );

            return {
                ...state,
                list: newList,
                totals: newList.length,
            };
        }

        default:
            return state;
    }
}
